import { render, staticRenderFns } from "./empresa-detalhe-fiscais.vue?vue&type=template&id=e170c644&"
import script from "./empresa-detalhe-fiscais.vue?vue&type=script&lang=js&"
export * from "./empresa-detalhe-fiscais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports